<template>
  <NewsModuleWrapper
    :class="[layoutStyle, touchState ? 'module-tapped' : 'not-tapped']"
    :bgcolor="color"
  >
    <LinkButton v-if="Data.link" :Color="color" :Link="Data.link ? Data.link : ''"/>
    <NewsContent v-if="Data.image" :bgcolor="color" :class="orientation">
      <MarqueeWrapper class="marquee-wrap">
        <marquee-text :duration="10" :repeat="4">
          <p v-html="Data.title"/>
        </marquee-text>
      </MarqueeWrapper>
    </NewsContent>
    <CurveText v-if="!Data.image" :bgcolor="color" class="curve-text">
      <svg width="1007px" height="1007px" viewBox="0 0 1007 1007" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
        <g id="V2" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
          <g id="Artboard" transform="translate(-285.000000, -102.000000)">
            <g id="Group" transform="translate(286.000000, 103.000000)">
              <circle id="Oval" cx="502.5" cy="502.5" r="502.5"></circle>
              <path id="curve" d="M475 502.5 475 502.5 479.896114 503.513936 484.177546 506.471479 487.272246 511.125079 488.690942 517.079373 488.062464 523.816004 485.162138 530.726423 479.931543 537.150828 472.488379 542.421069 463.125713 545.905084 452.300475 547.050326 440.611654 545.423672 428.769205 540.745439 417.555234 532.915438 407.779442 522.029377 400.2312 508.384432 395.630824 492.473341 394.582744 474.967019 397.533218 456.686273 404.735046 438.563811 416.221475 421.598301 431.790992 406.802656 451.004243 395.149156 473.193659 387.514187 497.485758 384.62553 522.835429 387.015058 548.070839 394.979525 571.94705 408.551772 593.20591 427.484249 610.639384 451.246148 623.153251 479.03483 629.827931 509.8015 629.973306 542.290382 623.17455 575.089963 609.326352 606.694199 588.653408 635.571044 561.715661 660.235202 529.39746 679.321708 492.88058 691.656773 453.601809 696.322386 413.196601 692.711303 373.430973 680.56946 336.124508 660.023325 303.067798 631.590348 275.938048 596.171444 256.216768 555.025207 245.113491 509.724475 243.499308 462.096661 251.853643 414.150107 270.227196 367.98941 298.223305 325.723305 334.999181 289.369123 379.287616 260.758114 429.438788 241.446029 483.480905 232.633229 539.197475 235.098272 594.218202 249.148425 646.119764 274.589872 692.53221 310.719559 731.246297 356.339693 760.316955 409.794902 778.158091 469.031035 783.624209 531.673577 776.0748 595.122702 755.418138 656.661176 722.131939 713.570616 677.259328 763.251154 622.379622 803.339238 559.554562 831.818275 491.251725 847.117007 420.247937 848.190919 349.51643 834.582631 282.102354 806.458053 220.991829 764.616099 168.980188 710.47085 128.545175 646.006287 101.730845 573.7049 90.0474965 496.452683 94.3924628 417.424136 114.995706 339.951828 151.393202 267.385899 202.429932 202.949407 266.29302 149.595769 340.574271 109.874576 422.360042 85.8118254 508.345116 78.8101332 594.966176 89.5737152 678.549469 118.061951 755.466555 163.474173 822.291531 224.267018 875.952936 298.204275 913.873625 382.437762 934.092295 473.616361 935.361001 568.019073 917.213961 661.706823 880.004078 750.686818 824.904941 831.082611 753.877547 899.302613 669.602466 952.199767 575.379711 987.215291 475 1002.5"></path>
              <text x="50">
                <textPath xlink:href="#curve">
                  {{Data.title}}
                </textPath>
              </text>
            </g>
          </g>
        </g>
      </svg>
    </CurveText>
    <CanvasThumb v-if="layoutStyle === 'canvas'">
      <TopImg v-if="Data.image" :class="`${orientation} top-img-wrapper`">
        <LazyImg :src="Data.image"/>
      </TopImg>
    </CanvasThumb>
    <TextureBg v-if="layoutStyle === 'texture' && Data.image" :Textures={textureArr}>
      <TopImg v-if="Data.image" :class="`${orientation} top-img-wrapper`">
        <LazyImg :src="Data.image"/>
      </TopImg>
    </TextureBg>
    <TextureWrapper v-if="layoutStyle === 'fullbg'">
      <TopImg v-if="Data.image" :class="`${orientation} top-img-wrapper`">
        <LazyImg v-if="Data.image" :src="Data.image" :fit="'contain'"/>
      </TopImg>
    </TextureWrapper>
  </NewsModuleWrapper>
</template>

<script>
import styled from 'vue-styled-components'
import Color from 'color'
import { colors, spacing, textures } from '@/styles/theme'
import * as _ from '@/styles/mixins'
import randomArrItem from '@/scripts/randomArrItem'
import LazyImg from '@/components/LazyImg'
import TextureBg from './TextureBg'
import LinkButton from './LinkButton'

// STYLES
const props = {
  bgcolor: String
}

const MarqueeWrapper = styled.div`
  overflow: hidden;
  p {
    ${_.sansFont};
    font-size: 1.85rem;
    text-align: center;
    white-space: nowrap;
    &:after {
      content: '/';
      padding-right: .5rem;
      padding-left: .5rem;
    }
  }
`

const NewsModuleWrapper = styled('div', props)`
  ${_.absoluteTopFull};
  background-color: ${props => Color(props.bgcolor).rotate(-195).lighten(0.3)};
  color: ${colors.black};
  overflow: hidden;
  .top-img {
    height: 100%;
    width: 100%;
    position: relative;
  }
  .top-img-wrapper,
  .curve-text {
    transition: filter 250ms ease-in-out;
    will-change: filter;
    filter: drop-shadow(0 0 0px ${props => Color(props.bgcolor).rotate(0)});
    z-index: 100;
  }
  &.texture {
    .top-img {
      padding: ${spacing.thumb_pad};
    }
  }
  &.module-tapped {
    .top-img-wrapper,
    .curve-text {
      filter: drop-shadow(0 0 25px ${props => Color(props.bgcolor).rotate(0)});
    }
    .link-button {
      transform: translateX(0);
    }
    .top-img-wrapper {
      transform: rotate(1.5deg);
    }
    .curve-text {
      animation-duration: 50s;
    }
  }
  ${_.media.hover`
    &:hover {
      .top-img-wrapper,
      .curve-text {
        filter: drop-shadow(0 0 50px ${props => Color(props.bgcolor).rotate(0)});
      }
      .link-button {
        transform: translateX(0);
      }
      .top-img-wrapper {
        transform: rotate(2deg);
      }
      .curve-text {
        animation-duration: 50s;
      }
    }
  `}
`

const NewsContent = styled('div', props)`
  position: absolute;
  z-index: 100;
  padding: 0;
  overflow: hidden;
  background-color: ${props => Color(props.bgcolor).lighten(0.125)};
  &.left,
  &.right {
    height: 100%;
    width: 6rem;
    .marquee-wrap {
      transform: rotate(90deg) translateY(-6rem);
      width: 100vw;
      height: 6rem;
      transform-origin: 0 0;
      position: absolute;
      top: 0;
      left: 0;
      ${_.flexCenteredAll};
      ${_.media.desktop`
        width: 50vh;
      `}
    }
  }
  &.top,
  &.bottom {
    ${_.flexCenteredAll};
    width: 100%;
    height: 6rem;
    left: 0;
    .marquee-wrap {
      height: 6rem;
      width: 100vw;
      ${_.flexCenteredAll};
      ${_.media.desktop`
        width: 50vw;
      `}
    }
    p {
      width: 100%;
    }
  }
  &.left {
    left: 0;
    border-right: 1px solid black;
  }
  &.right {
    right: 0;
    top: 0;
    border-left: 1px solid black;
  }
  &.top {
    top: 0;
    border-bottom: 1px solid black;
  }
  &.bottom {
    bottom: 0;
    border-top: 1px solid black;
  }
`

const CanvasThumb = styled.div`
  ${_.absoluteTopFull};
`

const TopImg = styled.div`
  height: 100%;
  width: 100%;
  position: relative;
  &.left {
    padding: ${spacing.thumb_pad};
    padding-left: calc(${spacing.thumb_pad} + 6rem);
  }
  &.right {
    padding: ${spacing.thumb_pad};
    padding-right: calc(${spacing.thumb_pad} + 6rem);
  }
  &.top {
    padding: ${spacing.thumb_pad};
    padding-top: calc(${spacing.thumb_pad} + 6rem)!important;
  }
  &.bottom {
    padding: ${spacing.thumb_pad};
    padding-bottom: calc(${spacing.thumb_pad} + 6rem)!important;
  }
`

const CurveText = styled('div', props)`
  ${_.absoluteCentered};
  ${_.flexCenteredAll};
  overflow: hidden;
  z-index: 100;
  height: 40vh;
  width: 40vh;
  animation: Rotation 5s linear infinite;
  transform-origin: center center;
  border: 3px solid ${props => Color(props.bgcolor).rotate(180)};
  border-radius: 50%;
  padding: 3%;
  background-color: ${colors.white};
  &:after {
    content: '';
    height: 2rem;
    width: 2rem;
    ${_.absoluteCentered};
    background-color: ${props => Color(props.bgcolor).rotate(180)};
    border-radius: 50%;
  }
  svg {
    width: 100%;
    height: 100%;
  }
  text {
    ${_.sansFont};
    font-size: 10rem;
    fill: ${props => props.bgcolor};
    letter-spacing: 2px;
  }
  path {
    fill: transparent;
  }
`

const TextureWrapper = styled.div`
  ${_.absoluteTopFull};
  z-index: 0;
  -webkit-backface-visibility: hidden;
  -webkit-transform:translate3d(0,0,0);
  .bg {
    ${_.absoluteTopFull};
    z-index: 0;
  }
`

// VUE
export default {
  props: [
    'Data',
    'touchState'
  ],
  components: {
    NewsModuleWrapper,
    CanvasThumb,
    NewsContent,
    TextureWrapper,
    LazyImg,
    TextureBg,
    CurveText,
    TopImg,
    MarqueeWrapper,
    LinkButton
  },
  data () {
    return {
      layoutStyle: false,
      orientation: false,
      color: randomArrItem(colors.fc),
      textureArr: textures.b
    }
  },
  created () {
    const layoutOptions = [
      'canvas',
      'texture',
      'fullbg'
    ]
    this.layoutStyle = randomArrItem(layoutOptions)
    const textOptions = [
      'top',
      'left',
      'bottom',
      'right'
    ]
    this.orientation = randomArrItem(textOptions)
  }
}
</script>
